/**
 * Auto-generated file created by svgr-cli source svgr.template.config.js
 * Run yarn svgr to update
 * Do not edit
 */
import * as React from 'react'
import { SVGProps, memo } from 'react'
const SvgContractCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || 24}
    height={props.height || 24}
    fill="currentColor"
    viewBox="0 0 40 40"
    color={props.color || '#EE4D2D'}
    {...props}
  >
    <rect width={40} height={40} fill="currentColor" rx={20} />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="m21.5 31 7-7V13a2 2 0 0 0-2-2h-13a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h8ZM15 15a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2h-8a1 1 0 0 1-1-1Zm1 3a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2h-8Z"
      clipRule="evenodd"
    />
    <path fill="#F7AF96" d="M21.5 31v-5a2 2 0 0 1 2-2h5l-7 7Z" />
  </svg>
)
const Memo = memo(SvgContractCircle)
export default Memo
